import { Pixall } from 'reaxl-analytics-handlers';

export async function enhancedHeroCtaClick(metadata = {}, option) {
    const { data = {}, dataLayer } = metadata;
    const { label } = data;

    Pixall.sendClickEvent({
        eventType: 'click',
        eventSource: 'application',
        label,
        adPlacementName: 'multi_image_header-editorial_content-client_provided_content-video_content',
        program: 'DealerDotCom',
        hasListingType: false,
    }, dataLayer, option);

    return {};
}

export async function enhancedHeroImpression(metadata = {}, option) {
    const { data = {}, dataLayer } = metadata;
    const { label } = data;

    Pixall.sendClickEvent({
        eventType: 'impression',
        eventSource: 'application',
        label,
        adPlacementName: 'multi_image_header-editorial_content-client_provided_content-video_content',
        program: 'DealerDotCom',
        hasListingType: false,
    }, dataLayer, option);

    return {};
}

export default {
    enhancedHeroCtaClick,
    enhancedHeroImpression,
};
